import React from 'react';
import { observer } from 'mobx-react';

import callApi from '../../utils/callApi';
import { ANCHOR_SERVICES } from '../../constants/anchorServices';
import {
  ANCHOR_VIEW,
  NNLIVE_VIEW,
  ANCHOR_SERVICES_URL,
  ANCHOR_VIDEOS_AND_GALLERIES_COUNT,
  FANZONES,
} from '../../constants/apiUrls/apiUrls';
import AnchorStore from '../../store/AnchorStore';
import GroupShowStore from '../../store/GroupShowStore';

import AnchorPageComponents from './AnchorPageComponents';
import NakedNewsLivePage from './NakedNewsLivePage';
import './css/Anchor.css';


@observer
class AnchorPage extends React.Component {
  state = {
    anchor: null,
    nakedNewsLiveAnchorData: null,
    anchorsList: [],
    anchorVideoUrl: null,
    chatService: null,
    chatServiceTem: null,
    streamService: null,
    guestUser: '',
    anchorId: null,
    itemCount: 0,
    showContextualOverlay: false,
    videosCount: 0,
    galleriesCount: 0,
    publicShowsCount: 0,
    isBanned: false,
    isSpotlighing: false,
    spotlighedAnchorUsername: null,
    spotlighedAnchorNickname: null,
    nakedNewsLivePromoClip: null,
    nakedNewsLivePromoImage: null,
    livePageAdData: {},
  };

  componentDidMount() {
    const anchorId = this.extractIdFromSlug();
    this.fetchFanzonesAnchorsList();
    this.fetchGalleriesAndVideosCountForBio(anchorId);
    this.fetchAnchor(anchorId);
  }

  componentWillUnmount() {
    AnchorStore.setIsAnchorLive(undefined);
    GroupShowStore.setInGroupShow(false);
  }

  setNakedNewsLivePageAd = (data) => {
    this.setState({ livePageAdData: data });
  };

  setItemsCount = (value) => {
    const data = value;
    this.setState({ itemCount: data });
  };

  fetchAnchor = (id) => {
    this.setState({ anchorId: id });
    const url = ANCHOR_VIEW.replace('{id}', id);
    callApi(url, 'get', {}).then((res) => {
      if (id === '241') {
        this.setState({ nakedNewsLiveAnchorData: res.data });
        callApi(NNLIVE_VIEW, 'get', {}).then((res) => {
          this.setState({ anchor: res.data }, () => this.setPageTitle());
        })
      } else {
        this.setState({ anchor: res.data }, () => this.setPageTitle());
      }
      this.fetchAnchorServicesUrls(res.data.username);
    });
  };

  fetchGalleriesAndVideosCountForBio = (id) => {
    const url = encodeURI(ANCHOR_VIDEOS_AND_GALLERIES_COUNT.replace('{id}', id));
    callApi(url, 'get', {}).then((res) => {
      this.setState({
        videosCount: res.data.totalPublicVideos,
        galleriesCount: res.data.totalPublicGalleries,
        publicShowsCount: res.data.totalLiveShows,
      });
    }).
      catch((err) => {
        console.log(err);
      });
  };

  fetchAnchorServicesUrls = (anchorName) => {
    const url = encodeURI(ANCHOR_SERVICES_URL.replace('{anchorName}', anchorName));
    callApi(url, 'GET', undefined, undefined, undefined, true, true, true).
      then((res) => {
        const guestUser = res.data.username;
        const { services } = res.data;
        const streamService = services.find((service) => service.name === ANCHOR_SERVICES.STREAM);
        const chatService = services.find((service) => service.name === ANCHOR_SERVICES.CHAT);
        const chatServiceTem = services.find((service) => service.name === ANCHOR_SERVICES.CHAT_TEMPTED);
        this.setState({ chatService, chatServiceTem, streamService, guestUser });
        if (res.data.profileStatus === 'IS_SPOTLIGHTING') {
          this.setState({
            isSpotlighing: true,
            spotlighedAnchorUsername: res.data.spotlightedTemptationUsername,
            spotlighedAnchorNickname: res.data.spotlightedTemptationNickname,
          });
          this.fetchSpotlightedAnchorServices(res.data.spotlightedTemptationUsername);
        } else {
          this.fetchAnchorActiveStream(anchorName, streamService);
        }
      }).
      catch((err) => {
        console.error(err);
      });
  };

  fetchSpotlightedAnchorServices = (anchorName) => {
    const url = encodeURI(ANCHOR_SERVICES_URL.replace('{anchorName}', anchorName));
    callApi(url, 'GET', undefined, undefined, undefined, true, true, true).
      then((res) => {
        const guestUser = res.data.username;
        const { services } = res.data;
        const streamService = services.find((service) => service.name === ANCHOR_SERVICES.STREAM);
        const chatService = services.find((service) => service.name === ANCHOR_SERVICES.CHAT);
        const chatServiceTem = services.find((service) => service.name === ANCHOR_SERVICES.CHAT_TEMPTED);
        this.setState({ chatService, chatServiceTem, streamService, guestUser });
        this.fetchAnchorActiveStream(anchorName, streamService);
      }).
      catch((err) => {
        console.error(err);
      });
  };

  fetchAnchorActiveStream = (anchorUsername, streamService) => {
    const url = encodeURI(`${streamService.url}/streams/${anchorUsername}/active`);
    callApi(url, 'get', {}, {}, { 'Authorization': `Bearer ${streamService.token}` }).
      then((res) => {
        if (res.data && res.data.length > 0) {
          if (!res.data[0].inGroupShow) {
            if (res.data[0].provider === 'WOWZA') {
              this.setState({ anchorVideoUrl: res.data[0] });
              AnchorStore.setIsAnchorLive(true);
            }

            if (res.data[0].provider === 'STREAMING_SAAS') {
              this.setState({ anchorVideoUrl: res.data[0] });
              AnchorStore.setIsAnchorLive(true);
            }

            if (res.data[0].provider === 'CAM4_STREAMING_SAAS') {
              this.setState({ anchorVideoUrl: res.data[0] });
              AnchorStore.setIsAnchorLive(true);
            }
          } else {
            GroupShowStore.getAnchorServices(anchorUsername);
          }
        } else {
          GroupShowStore.getAnchorServices(anchorUsername);
          AnchorStore.setIsAnchorLive(false);
        }
      }).
      catch((error) => {
        console.error(error);
      });
  };

  extractIdFromSlug = () => {
    const { slug, isLive } = this.props;
    const digitArray = slug?.match(/\d/g);

    return isLive ? '241' : digitArray.join('');
  };

  setPageTitle = () => {
    const page = this.props.isLive ? 'Live' : this.state.anchor.name;
    document.title = `${page} | Naked News`;
  };

  fetchFanzonesAnchorsList = () => {
    callApi(FANZONES).then((res) => {
      this.setState({ anchorsList: res.data });
    });
  };

  setNakedNewsLivePromoUrl = (clipUrl, imageUrl) => {
    this.setState({
      nakedNewsLivePromoClip: clipUrl,
      nakedNewsLivePromoImage: imageUrl,
    });
  };

  setBanStatus = (value) => {
    this.setState({ isBanned: value });
  };

  toggleContextualJoinOverlay = (flag) => {
    this.setState({ showContextualOverlay: flag });
  };

  fetchStreamDetails = () => {
    this.fetchAnchor(this.state.anchorId);
  };

  onNetworkError = () => {
    const { anchor } = this.state;
    this.fetchAnchorServicesUrls(anchor.username);
  };

  render() {
    const {
      anchor,
      anchorsList,
      anchorVideoUrl,
      chatService,
      chatServiceTem,
      guestUser,
      anchorId,
      itemCount,
      showContextualOverlay,
      isBanned,
      isSpotlighing,
      spotlighedAnchorUsername,
      spotlighedAnchorNickname,
      nakedNewsLivePromoClip,
      nakedNewsLivePromoImage,
      livePageAdData,
      nakedNewsLiveAnchorData,
    } = this.state;
    const { slug, anchorPortalCampaign } = this.props;

    if (anchor === null) {
      return false;
    }
    // commented out to allow guest and past anchors to stream
    // const isImageLayout = anchor.guest || !anchor.active ? true : false;
    let isImageLayout = false;

    if (anchorVideoUrl) {
      isImageLayout = false;
    } else if (anchor.guest) {
      isImageLayout = false;
    } else {
      isImageLayout = !!(anchor.guest || !anchor.active);
    }
    const { location, user, history } = this.props;
    const isLivePage = slug === 'live' || slug === 'home' && window.location.hostname.includes('nakednewslive');
    const pageItemsShown = 6;
    const showFanZone = anchor.hasFanzone;
    const props = {
      anchor,
      anchorsList,
      anchorId,
      anchorVideoUrl,
      chatService,
      chatServiceTempted: chatServiceTem,
      extractIdFromSlug: this.extractIdFromSlug,
      fetchStreamDetails: this.fetchStreamDetails,
      guestUser,
      history,
      isBanned,
      toggleContextualJoinOverlay: this.toggleContextualJoinOverlay,
      showFanZone,
      slug,
      user,
      onNetworkError: this.onNetworkError,
      authenticated: user.authenticated,
      galleriesAndVideosCount: itemCount,
      isImageLayout,
      loggedInUsername: user.user ? user.user.username : '',
      promoThumbnail: anchor.fanzonePromopic,
      promoVideo: anchor.promoClip,
      totalGalleriesCount: this.state.galleriesCount,
      totalPublicShowsCount: this.state.publicShowsCount,
      totalVideosCount: this.state.videosCount,
      anchorPortalCampaign,
      showOverlay: showContextualOverlay,
      location,
      pageItemsShown,
      setBanStatus: this.setBanStatus,
      setItemsCount: this.setItemsCount,
      showClipStore: anchor.showClipStore,
      isSpotlighing,
      spotlighedAnchorUsername,
      spotlighedAnchorNickname,
      nakedNewsLivePromoClip,
      nakedNewsLivePromoImage,
      livePageAdData,
      nakedNewsLiveAnchorData,
      setNakedNewsLivePageAd: this.setNakedNewsLivePageAd,
      setNakedNewsLivePromoUrl: this.setNakedNewsLivePromoUrl,
    };

    if (isLivePage) {
      return (
        <div className="current live-page-container fanzone" id="anchors-show">
          <NakedNewsLivePage {...props} />
        </div>
      );
    }

    return (
      <div className="current fanzone" id="anchors-show">
        <AnchorPageComponents {...props} />
      </div>
    );
  }
}

export default AnchorPage;

